import React from 'react';
import './LogoutButton.css';

const LogoutButton = ({ onLogout }) => {
  const handleLogout = () => {
    if (window.confirm('¿Estás seguro de que quieres cerrar sesión?')) {
      onLogout();
    }
  };

  return (
    <button onClick={handleLogout} className="logout-button" title="Cerrar sesión">
      <span className="logout-icon">🚪</span>
      Cerrar sesión
    </button>
  );
};

export default LogoutButton;